export const allDepartmentsForDropdown = [
  {
    id: 'bd42d86f-d341-4d80-a1b7-5500c008be2f',
    name: 'Sales Department',
  },
  {
    id: 'ec639679-fff8-49d1-b863-b389f8a0e123',
    name: 'Development Department',
  },
  {
    id: '71ef5c0e-b3a6-4709-b2fc-1094477527c3',
    name: 'Design Department',
  },
  {
    id: 'c72ace04-8daa-46a8-9d4f-052bb5d642d0',
    name: 'Marketing Department',
  },
];
